export default {
  language: { label: 'Sprache', en: 'English', de: 'Deutsch' },
  analytics: { ariaLabel: 'Einwilligung zu Analyse-Cookies', title: 'Analyse-Cookies', description: 'Mit deiner Zustimmung nutzen wir Google Analytics, um zu verstehen, wie No Context Games genutzt wird. Details findest du in der Datenschutzerklärung.', decline: 'Ablehnen', accept: 'Akzeptieren' },
  nav: { allGames: 'Alle Spiele', joinRoom: 'Raum beitreten', back: 'Zurück', close: 'Schließen', main: 'Hauptnavigation' },
  status: { live: 'Live', reconnecting: 'Verbindung wird hergestellt', waitingForHost: 'Warten auf den Host', host: 'Host' },
  room: { room: 'Raum', roomCode: 'Raumcode', inviteCode: 'Einladungscode' },
  game: { round: 'Runde {{current}} / {{total}}', players: '{{count}} / 8 Spieler dabei' },
  actions: { next: 'Weiter', shareInvite: 'Einladung teilen', copied: 'Kopiert!', copyRoomLink: 'Raumlink kopieren', playAgain: 'Nochmal spielen', remove: '{{name}} entfernen', mute: 'Ton ausschalten', soundOn: 'Ton einschalten' },
  loading: {
    connecting: 'Verbindung zum Spiel wird hergestellt…',
    failedTitle: 'Neue Dateien nötig',
    failedMessage: 'Dein Browser hat noch eine ältere Spieldatei. Lade einmal neu, um die aktuelle Version zu holen.',
    retry: 'Spiel neu laden',
  },
  errors: {
    TIMEOUT: 'Der Spielserver antwortet nicht. Prüfe deine Verbindung und versuche es erneut.',
    SERVER_ERROR: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
    INVALID_NAME: 'Namen müssen zwischen 2 und 20 Zeichen lang sein.',
    NAME_TAKEN: 'Jemand in diesem Raum hat bereits diesen Namen.',
    ROOM_NOT_FOUND: 'Dieser Raum wurde nicht gefunden.',
    ROOM_FULL: 'Dieser Raum ist voll.',
    GAME_STARTED: 'Dieses Spiel hat bereits begonnen.',
    NOT_ENOUGH_PLAYERS: 'Mindestens drei Spieler werden benötigt.',
    BAD_PHASE: 'Diese Aktion ist gerade nicht verfügbar.',
    NOT_ALLOWED: 'Du darfst diese Aktion nicht ausführen.',
    PLAYER_NOT_FOUND: 'Dieser Spieler ist nicht mehr im Raum.',
    INVALID_FACTS: 'Gib drei unterschiedliche Aussagen mit jeweils 3 bis 120 Zeichen ein.',
    INVALID_GLITCH: 'Wähle aus, welche Aussage der Glitch ist.',
    NOT_SUBJECT: 'Du bist gerade nicht mit dem Einreichen dran.',
    ALREADY_VOTED: 'Deine Stimme ist bereits eingeloggt.',
    INVALID_REASON: 'Wähle einen der Gründe auf dem Stimmzettel.',
    WAITING_FOR_VOTES: 'Warte auf alle anonymen Stimmzettel.',
    NOT_SPOTLIGHT: 'Nur die Person im Fokus kann die Haltung wählen.',
    STANCE_LOCKED: 'Deine Haltung ist bereits festgelegt.',
    INVALID_STANCE: 'Wähle, ob du das Urteil annimmst oder Einspruch erhebst.',
    WAITING_FOR_STANCE: 'Die Person im Fokus muss zuerst eine Haltung wählen.',
    NOT_GUEST: 'Nur der heutige Gast kann diese Wahl treffen.',
    INVALID_CRAVING: 'Wähle eine Sehnsucht aus dem privaten Menü.',
    GUEST_CANNOT_COOK: 'Der Gast bestellt und kocht nicht.',
    DISH_SUBMITTED: 'Dein Gericht steht bereits am Pass.',
    INVALID_BASE: 'Wähle einen Teller aus dieser Küche.',
    INVALID_TWIST: 'Wähle ein Finish aus dieser Küche.',
    WAITING_FOR_DISHES: 'Warte, bis alle Köche ein Gericht angerichtet haben.',
    INVALID_DISH: 'Wähle ein Gericht aus dem heutigen geheimen Menü.',
    ORDER_LOCKED: 'Die Bestellung des Gastes ist bereits festgelegt.',
    GUEST_CANNOT_BET: 'Der Gast bestellt stattdessen.',
    BET_LOCKED: 'Deine Tischwette ist bereits festgelegt.',
    WAITING_FOR_TASTING: 'Warte auf die Gastbestellung und alle Tischwetten.',
    NOT_PLAYING: 'Du gehörst nicht zu diesem Spiel.',
    NOT_CALLER: 'Nur der aktuelle Anrufer darf das tun.',
    DILEMMA_SUBMITTED: 'Dieses Dilemma wurde bereits eingereicht.',
    INVALID_NEED: 'Wähle, was du ehrlich von der Runde brauchst.',
    INVALID_DILEMMA: 'Dein Dilemma muss zwischen 12 und 180 Zeichen lang sein.',
    CALLER_CANNOT_ADVISE: 'Der Anrufer kann das eigene Dilemma nicht beantworten.',
    ADVICE_SUBMITTED: 'Dein Rat wurde bereits eingereicht.',
    INVALID_ADVICE_TEXT: 'Schlechter Rat muss zwischen 12 und 160 Zeichen lang sein.',
    INVALID_FINE_PRINT: 'Das Kleingedruckte muss zwischen 8 und 140 Zeichen lang sein.',
    WAITING_FOR_ADVICE: 'Warte, bis alle Berater eine Antwort eingereicht haben.',
    INVALID_ADVICE: 'Wähle einen Rat aus dieser Fallakte.',
    ADVICE_SELF_VOTE: 'Du kannst deinem eigenen Rat keine Haftung geben.',
    TEMPTATION_LOCKED: 'Deine verlockende Wahl ist bereits festgelegt.',
    INVALID_TACTIC: 'Wähle eine Katastrophen-Taktik.',
    WAITING_FOR_VERDICTS: 'Warte auf alle Haftungsstempel und die Wahl des Anrufers.',
    NOT_SENDER: 'Nur der aktuelle Absender darf das tun.',
    DRAFT_SUBMITTED: 'Diese Nachricht ist bereits im Multiversum.',
    INVALID_UNSENT_REASON: 'Wähle, warum die Nachricht ungesendet blieb.',
    INVALID_RECIPIENT: 'Die Empfängerbezeichnung muss zwischen 2 und 30 Zeichen lang sein.',
    INVALID_MESSAGE: 'Die Nachricht muss zwischen 12 und 220 Zeichen lang sein.',
    SENDER_CANNOT_REPLY: 'Der Absender kann die eigene Nachricht nicht beantworten.',
    REPLY_SUBMITTED: 'Deine Zeitlinie wurde bereits gespeichert.',
    INVALID_REPLY: 'Die Antwort muss zwischen 8 und 180 Zeichen lang sein.',
    INVALID_AFTERSHOCK: 'Die Folge muss zwischen 8 und 140 Zeichen lang sein.',
    WAITING_FOR_REPLIES: 'Warte auf alle parallelen Antworten.',
    INVALID_TIMELINE: 'Wähle eine Antwort aus diesem Posteingang.',
    SENDER_CANNOT_VOTE: 'Der Absender öffnet stattdessen eine Zeitlinie.',
    UNSENT_SELF_VOTE: 'Du kannst deine eigene Zeitlinie nicht verstärken.',
    TIMELINE_OPENED: 'Du hast bereits eine Zeitlinie geöffnet.',
    WAITING_FOR_INBOX: 'Warte auf alle Signale und die Wahl des Absenders.',
    INVALID_UNSENT_DECISION: 'Entscheide, ob du bleibst oder die Zeitlinie wechselst.',
    SAME_TIMELINE: 'Wechsle zu einer anderen Zeitlinie.',
    WAITING_FOR_REROUTE: 'Warte, bis der Absender die Zeitlinie festlegt.',
    SUBJECT_CANNOT_VOTE: 'Der Erzähler darf nicht abstimmen.',
    INVALID_VOTE: 'Diese Auswahl ist nicht verfügbar.',
    ALREADY_SUBMITTED: 'Dein Pitch liegt bereits im Konferenzraum.',
    INVALID_PRODUCT_NAME: 'Produktnamen müssen zwischen 3 und 40 Zeichen lang sein.',
    INVALID_PITCH: 'Dein Pitch muss zwischen 10 und 180 Zeichen lang sein.',
    SELF_VOTE: 'Selbst CEOs dürfen nicht für sich selbst stimmen.',
    NOT_ENOUGH_PITCHES: 'Zum Abstimmen werden mindestens zwei Pitches benötigt.',
    ANSWER_LOCKED: 'Deine Antwort ist bereits eingeloggt.',
    ABILITY_USED: 'Du hast dein Gadget bereits benutzt.',
    INVALID_ROLE: 'Deine Crew-Rolle wurde nicht gefunden.',
    ROLE_LOCKED: 'Deine Crew-Rolle ist bereits festgelegt.',
    NO_GADGET_CHARGES: 'Du hast keine Züge mehr übrig.',
    INVALID_TARGET: 'Wähle einen anderen Spieler in diesem Coup.',
    INVALID_ANSWER: 'Diese Antwort ist nicht verfügbar.',
    NO_ANSWERS: 'Warte auf mindestens eine Antwort, bevor der Tresor geknackt wird.',
    INVALID_ALIBI: 'Dein Alibi muss zwischen 8 und 160 Zeichen lang sein.',
    NOT_ENOUGH_ALIBIS: 'Für das Verhör werden mindestens zwei Alibis benötigt.',
    CULPRIT_CANNOT_VOTE: 'Der Täter muss stattdessen den Beweis identifizieren.',
    NOT_CULPRIT: 'Nur der Täter kann den Beweis identifizieren.',
    ALREADY_GUESSED: 'Dein Beweistipp ist bereits festgelegt.',
    INVALID_EVIDENCE: 'Wähle einen Beweis aus diesem Fall.',
    INVALID_SUSPECT: 'Wähle jemanden aus dem Club.',
    ALIBI_SUBMITTED: 'Deine Aussage ist bereits zu Protokoll.',
    SELF_ACCUSATION: 'Du weißt, dass du es nicht warst. Klage jemand anderen an.',
    INVALID_DRAWING: 'Diese Zeichnung enthält zu viel Tinte oder ungültige Striche. Nimm ein paar Striche zurück und versuche es erneut.',
    DRAWING_SUBMITTED: 'Diese Zeichnung ist bereits festgelegt.',
    NOT_ENOUGH_DRAWINGS: 'Zum Fortfahren werden mindestens zwei Zeichnungen benötigt.',
    SELF_RESCUE_VOTE: 'Du kannst die Rettung deiner eigenen Erfindung nicht auszeichnen.',
    SELF_SABOTAGE_VOTE: 'Du kannst deine eigene Sabotage nicht auszeichnen.',
    INVALID_LIVE_ACTION: 'Diese Konsolenbewegung war ungültig. Versuche es beim nächsten Signalruf.',
    ACTION_WINDOW_CLOSED: 'Dieses Signalfenster ist bereits geschlossen.',
    ACTION_LOCKED: 'Deine Antwort auf diesen Ruf ist bereits festgelegt.',
    NO_ACTIVE_SIGNAL: 'Warte auf einen aktiven Signalruf, bevor du das Notfallpult benutzt.',
    NO_SIGNAL_CHARGES: 'Dein Notfallpult hat keine Ladungen mehr.',
    WRONG_GAME: 'Dieser Raum gehört zu einem anderen Spiel.',
    WRONG_MODE: 'Dieser Raum wird über das Handy des Hosts gesteuert.',
    INVALID_MODE: 'Wähle eine gültige Spielweise.',
    INVALID_GAME: 'Wähle ein gültiges Spiel.',
    missingSession: 'Deine Spielsitzung fehlt. Tritt dem Raum erneut bei.',
    hostSessionMissing: 'Der Host-Schlüssel für diesen Raum fehlt.',
  },
}
